
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createCategory, deleteCategory, bulkCreateCategories, updateCategory } from '@/services/categoryService';
import { CategoryType } from '@/constants/categoryTypes';

export const useCreateCategory = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (params: { name: string; categoryType?: CategoryType }) => 
      createCategory(params.name, params.categoryType),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['categories'] });
      queryClient.invalidateQueries({ queryKey: ['categories-with-details'] });
    }
  });
};

export const useUpdateCategory = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (params: { oldName: string; newName: string; status?: string; category_type?: CategoryType }) => 
      updateCategory(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['categories'] });
      queryClient.invalidateQueries({ queryKey: ['categories-with-details'] });
      // Also invalidate products with details as they might reference this category
      queryClient.invalidateQueries({ queryKey: ['products-with-details'] });
    }
  });
};

export const useDeleteCategory = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (categoryName: string) => deleteCategory(categoryName),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['categories'] });
      queryClient.invalidateQueries({ queryKey: ['categories-with-details'] });
    }
  });
};

export const useBulkCreateCategories = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (params: { names: string[]; categoryType?: CategoryType }) => 
      bulkCreateCategories(params.names, params.categoryType),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['categories'] });
      queryClient.invalidateQueries({ queryKey: ['categories-with-details'] });
    }
  });
};
